import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=97ed246e&scoped=true"
import script from "./crumbs.vue?vue&type=script&lang=js"
export * from "./crumbs.vue?vue&type=script&lang=js"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=97ed246e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ed246e",
  null
  
)

export default component.exports